import { Tooltip } from "antd";
import React from 'react';
import LoadingBox from "../../../../components/LoadingBox";
import { openPopup2 } from "../../../../contexts/PopupContext";
import { selectPermissions } from '../../../../util/store/selectors';
import { useSelector } from '../../../../util/store/store';
import { ACTION_TYPE } from "../../../../util/varibles/constants";
import { ACTION } from '../../../../util/varibles/permission';
import { initWidget } from "../../constants";
import PopupEditWidget from "../PopupEditWidget";
import ButtonLive from "./ButtonLive";
import ButtonPlay from "./ButtonPlay";
import ControlComponent from "./ControlComponent";
import CurrentTime from "./CurrentTime";
import Pointer from "./Pointer";
import RulerComponent from "./RulerComponent";
import styles from "./style.module.scss";

interface IProps {
    loading: boolean

    loadData(time?: { start_time: number, end_time: number }): void
}

const Timeline: React.FC<IProps> = React.memo(({ loading, loadData }) => {
    const [canUpdateVessel] = useSelector(selectPermissions([ACTION.VESSEL.UPDATE]));

    const handleAddWidget = () => {
        openPopup2(<PopupEditWidget
            widget={initWidget}
            editMode={ACTION_TYPE.CREATE}
        />, { modalProps: { title: "Add new widget" } })
    }

    return <div className={styles['container-timeline']}>
        <div className={styles.timeline}>
            <div id='container-ruler' className={styles['container-ruler']}>
                <Pointer loading={loading} />
                <CurrentTime />
                <RulerComponent />
                {loading && <LoadingBox loading level="bg" />}
            </div>
        </div>
        <div className='flex align-center justify-between gap-[10px] py-[6px] px-[12px]'>
            <div className='flex align-center gap-[10px]'>
                <ButtonPlay loading={loading} />
                <ButtonLive loadData={loadData} />
                <ControlComponent loading={loading} loadData={loadData} />
            </div>
            {canUpdateVessel && <Tooltip title='Add widget'>
                <div className={styles['button-plus']} onClick={handleAddWidget} />
            </Tooltip>}
        </div>
    </div>;
}, (prevProps, nextProps) => prevProps.loading === nextProps.loading);

export default Timeline;
